import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-freight-rate-sets',
  templateUrl: './freight-rate-sets.component.html',
  styleUrls: ['./freight-rate-sets.component.css']
})
export class FreightRateSetsComponent implements OnInit {
    public custNo: string;

    public setting?: Setting;

    public itemsListRateSets: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.custNo = this.stateService.getStateParams()['cust_no'];
    }

    private async loadSetting() {
        if (!!this.custNo) {
            this.setting = (await this.datatask.Post(1553, { cust_no: this.custNo }))[0];
        }
    }

    private async loadRateSets() {
        if (!!this.custNo) {
            this.itemsListRateSets = await this.datatask.Post(1541, { cust_no: this.custNo });
        }
    }

    private async init() {
        this.loadSetting();
        this.loadRateSets();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    from_supplier_name: string;
}
